import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../contents/ganttDiagram/Layout';
import SEO from '../../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="Learn Gantt diagrams" description="Learn how to turn code into Gantt diagrams and integrate it in one click in GitHub, Notion, and more." mdxType="SEO" />
    <h1>{`Gantt diagram `}<em parentName="h1">{`Documentation`}</em></h1>
    <h2>{`Tasks`}</h2>
    <p>{`The length and offset of each tasks is defined by the number of characters you use.
You must precede a task's name by at least one space.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gantt"
      }}>{`---- Task1
    ---------- Task 2
`}</code></pre>
    <h2>{`Style`}</h2>
    <p>{`You can customize the style of each task by changing the character you use to define the length.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gantt"
      }}>{`---- Default
==== Thick
.... Dotted
`}</code></pre>
    <h2>{`Multi-lines`}</h2>
    <p>{`You can add line breaks using `}<inlineCode parentName="p">{`\\n`}</inlineCode>{` or using quotes around your strings.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gantt"
      }}>{`--- Multiple\\nlines

---- "Quoted
multiple
lines"
`}</code></pre>
    <h2>{`Line caps`}</h2>
    <p>{`You can add line caps at any end of your tasks.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gantt"
      }}>{`|---| Task 1
    |=====< Task 2
      >...< Task 3
`}</code></pre>
    <h2>{`Instant tasks`}</h2>
    <p>{`You can use caps to create instant tasks.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gantt"
      }}>{`>< Task 1
 | Task 2
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      